import { useAppSelector } from 'shared/lib/store';
import { selectIsTimeslotUtc } from '../../model/selectors';
import { formatISODate } from 'shared/lib/datepicker';
import { TDay } from 'shared/types';
import { replaceTimeInISODate } from 'shared/lib/time';

export const useTimeslotZone = () => {
	const isTimeslotUtc = useAppSelector(selectIsTimeslotUtc);

	const formatISODateBySlotZone = (date: TDay) => {
		return formatISODate(date, !isTimeslotUtc);
	};

	const replaceTimeInISODateBySlotZone = (
		isoDate: string,
		newTime: string,
	) => {
		return replaceTimeInISODate(isoDate, newTime, !isTimeslotUtc);
	};

	return { formatISODateBySlotZone, replaceTimeInISODateBySlotZone };
};
